import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    teams: []
};

const teamSlice = createSlice({
    name: "teams",
    initialState,
    reducers: {
        createTeam: (state, action) => {
            const teamName  = action.payload;
            const exists = state.teams.some(team => team[0] === teamName);

            if (!exists) {
                state.teams.push([teamName]);
            }
        },

        addPokemon: (state, action) => {
            const { teamName, memberName } = action.payload;

            const team = state.teams.find(team => team[0] === teamName);
            if (team) {
                team.push(memberName);
            }
        },
        removePokemon: (state,action) => {
            const { teamName, memberName } = action.payload;
            const team = state.teams.find(team => team[0] === teamName);
            for(let i = 1; i< team.length;i++)
            {
                if(team[i] === memberName)
                    team[i].splice(i,1)
            }
        },
        removeTeam: (state,action) => {
            const teamName = action.payload;
            let a = 0;
            for(let i = 0; state.teams.length;i++)
            {
                if(state.teams[i].team[0] === teamName)
                    a = i
            }
            state.teams.splice(a,1)
        },
        removeAllPokemon: (state,action) => {
            const teamName = action.payload;
            const team = state.teams.find(team => team[0] === teamName);
            team.splice(1,69)
        }

    }
});

export const { createTeam, addPokemon,removeTeam,removeAllPokemon,removePokemon } = teamSlice.actions;
export default teamSlice.reducer;
